import { useTheme } from '../context/ThemeContext';
import { DarkThemeIcon, LightThemeIcon } from './Icons';

function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  return (
    <div className="theme-toggle" role="group" aria-label="Theme">
      <button
        type="button"
        className={`theme-toggle__option ${theme === 'light' ? 'theme-toggle__option--active' : ''}`}
        onClick={() => setTheme('light')}
        aria-label="Light mode"
        aria-pressed={theme === 'light'}
      >
        <LightThemeIcon />
      </button>
      <button
        type="button"
        className={`theme-toggle__option ${theme === 'dark' ? 'theme-toggle__option--active' : ''}`}
        onClick={() => setTheme('dark')}
        aria-label="Dark mode"
        aria-pressed={theme === 'dark'}
      >
        <DarkThemeIcon />
      </button>
    </div>
  );
}

export default ThemeToggle;
